<template lang="html">
  <div class="fineart-page" :class="{'has-position': pageHasPosition}">
    <div class="page-container"><slot></slot></div>
    <fineart-foot></fineart-foot>
  </div>
</template>

<script>
import FineartFoot from './FineartFoot.vue'
import { mapState } from 'vuex'
export default {
  name: 'page',
  data () {
    return {}
  },
  components: {
    FineartFoot
  },
  computed: {
    ...mapState(['pageHasPosition'])
  }
}
</script>

<style lang="stylus">
.fineart-page
  padding-top: 80px
  padding-bottom: 60px
  min-height: 100%
  z-index: 1
.has-position
  position: relative
</style>



// WEBPACK FOOTER //
// src/components/Page.vue